<template>
  <v-menu close-on-content-click
          open-on-hover offset-y
          close-delay="300">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="normal-btn-text body-1 font-weight-bold ml-3"
        v-on="on">
        Gestão de compras
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        link
        active-class="orange--text"
        :disabled="!hasRoleComprador && !hasRoleRequisicao && !hasRoleGestorCompras"
        to="/requisicoes"
      >
        <v-list-item-icon>
          <v-icon>mdi-package-up</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Solicitações de compra</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        active-class="orange--text"
        :disabled="!hasRoleAprovadorRequisicao&& !hasRoleRequisicao
        && !hasRoleGestorCompras && !hasRoleComprador"
        to="/aprovacoes-solicitacoes"
      >
        <v-list-item-icon>
          <v-icon>mdi-package-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            Aprovações de solicitações
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        active-class="orange--text"
        :disabled="!hasRoleComprador && !hasRoleGestorCompras"
        to="/cotacoes"
      >
        <v-list-item-icon>
          <v-icon>mdi-currency-usd</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Cotações</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleAprovador && !hasRoleComprador && !hasRoleGestorCompras"
        active-class="orange--text"
        to="/aprovacoes-compras"
      >
        <v-list-item-icon>
          <v-icon>mdi-check-circle-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Aprovações de compras</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasRoleComprador && !hasRoleAprovador && !hasRoleGestorCompras"
        active-class="orange--text"
        to="/compras"
      >
        <v-list-item-icon>
          <v-icon>mdi-shopping</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Compras</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="hasControleEntrega || hasRoleGestorCompras"
        link
        :disabled="!hasRoleGestorEntrega && !hasRoleGestorCompras"
        active-class="orange--text"
        to="/gesta-entregas">
        <v-list-item-icon>
          <v-icon>mdi-truck</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Entregas</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['user', 'hasRoleComprador', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasRoleAprovadorRequisicao', 'hasRoleGestorEntrega', 'hasRoleGestorCompras']),
    ...mapGetters('entidade', ['hasControleEntrega']),
  },
};
</script>
